import { forwardRef } from 'react';
import { classes } from 'utils/style';
import styles from './Icon.module.css';
import ArrowLeft from './svg/arrow-left.svg';
import ArrowRight from './svg/arrow-right.svg';
import Check from './svg/check.svg';
import ChevronRight from './svg/chevron-right.svg';
import Close from './svg/close.svg';
import Copy from './svg/copy.svg';
import Error from './svg/error.svg';
import Eye from './svg/eye.svg';
import EyeOff from './svg/eye-off.svg';
import Figma from './svg/figma.svg';
import Linkedin from './svg/linkedin.svg';
import Github from './svg/github.svg';
import Link from './svg/link.svg';
import Menu from './svg/menu.svg';
import Palette from './svg/palette.svg';
import Pause from './svg/pause.svg';
import Play from './svg/play.svg';
import Reset from './svg/reset.svg';
import Send from './svg/send.svg';
import X from './svg/x.svg';

export const icons = {
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  check: Check,
  chevronRight: ChevronRight,
  close: Close,
  copy: Copy,
  error: Error,
  eye: Eye,
  eyeOff: EyeOff,
  figma: Figma,
  github: Github,
  link: Link,
  linkedin: Linkedin,
  menu: Menu,
  palette: Palette,
  pause: Pause,
  play: Play,
  reset: Reset,
  send: Send,
  x: X,
};

export const Icon = forwardRef(({ icon, className, ...rest }, ref) => {
  const IconComponent = icons[icon];

  return (
    <IconComponent
      ref={ref}
      aria-hidden
      className={classes(styles.icon, className)}
      {...rest}
    />
  );
});

Icon.displayName = 'Icon';
